export default "/images/vendor/@coreui/icons/svg/flag/cif-sd.svg?85c31bd1e15b1eb9aa41a1b65528e163";